import React from 'react';
import { MapPin, Clock, Mail, Globe } from 'lucide-react';
import WhatsAppIcon from './icons/WhatsAppIcon';

export default function NAPSection() {
  return (
    <section id="contact-info" className="py-12 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-16">
          <span className="inline-flex items-center gap-2 bg-brown-100 text-brown-700 px-4 py-2 rounded-full text-sm font-cairo font-medium mb-4">
            <MapPin size={16} />
            معلومات التواصل
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-amiri font-bold text-gray-900 mb-4">
            كيف تتواصل معنا؟
          </h2>
          <p className="text-gray-600 font-cairo max-w-2xl mx-auto text-sm md:text-base">
            سدرة المنتهى للخدمات السياحية والعمرة — نحن هنا لمساعدتك في رحلتك الإيمانية
          </p>
        </div>

        {/* NAP Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {/* WhatsApp */}
          <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all group">
            <div className="w-14 h-14 bg-green-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              <WhatsAppIcon className="w-7 h-7 text-white" />
            </div>
            <h3 className="font-cairo font-bold text-gray-900 mb-2">واتساب</h3>
            <a
              href="https://wa.me/966575179602?text=السلام عليكم، أريد الاستفسار عن خدمات العمرة"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-600 font-cairo font-bold text-lg block mb-1 hover:underline"
            >
              احجز عبر واتساب
            </a>
            <p className="text-gray-500 font-cairo text-sm">رد سريع وتأكيد فوري</p>
          </div>

          {/* Location */}
          <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all group">
            <div className="w-14 h-14 bg-brown-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              <MapPin className="w-7 h-7 text-white" />
            </div>
            <h3 className="font-cairo font-bold text-gray-900 mb-2">الموقع</h3>
            <p className="text-brown-600 font-cairo font-bold mb-1">الرياض، المملكة العربية السعودية</p>
            <p className="text-gray-500 font-cairo text-sm">ننطلق من الرياض يومياً</p>
          </div>

          {/* Working Hours */}
          <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all group">
            <div className="w-14 h-14 bg-gold-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              <Clock className="w-7 h-7 text-white" />
            </div>
            <h3 className="font-cairo font-bold text-gray-900 mb-2">مواعيد العمل</h3>
            <p className="text-gold-600 font-cairo font-bold mb-1">يومياً 24 ساعة</p>
            <p className="text-gray-500 font-cairo text-sm">رد على واتساب على مدار الساعة</p>
          </div>
        </div>

        {/* SEO Text Block */}
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-lg border border-gray-100">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-2xl font-amiri font-bold text-gray-900 mb-6 text-center">
              سدرة المنتهى — أفضل شركة عمرة من الرياض
            </h3>
            <div className="prose prose-lg font-cairo text-gray-600 leading-relaxed space-y-4">
              <p>
                <strong className="text-gray-800">سدرة المنتهى للخدمات السياحية والعمرة</strong> هي إحدى أقدم وأشهر الشركات المتخصصة في تنظيم رحلات العمرة من الرياض إلى مكة المكرمة والمدينة المنورة. تأسست الشركة منذ أكثر من عشر سنوات بهدف تقديم أفضل خدمات العمرة لضيوف الرحمن من أهل الرياض والمملكة العربية السعودية.
              </p>
              <p>
                نقدم <strong className="text-gray-800">باقات عمرة من الرياض</strong> تناسب جميع الميزانيات والاحتياجات. سواء كنت تبحث عن رحلة عمرة اقتصادية بسعر مناسب أو رحلة VIP فاخرة، سدرة المنتهى توفر لك الباقة المثالية. تشمل باقاتنا النقل بالباص الحديث موديل 2027 والإقامة في فنادق مختارة بعناية من 3 إلى 5 نجوم والمتابعة والمتابعة مع مرشد دني متخصص.
              </p>
              <p>
                ننطلق من <strong className="text-gray-800">الرياض يومياً تقريباً</strong> في رحلات عمرة منظمة إلى مكة المكرمة. الباصات الاقتصادية تسع 49 مقعداً وباصات VIP تسع 30 مقعداً فقط لراحة أكبر. الفنادق قريبة من الحرم المكي والمسجد النبوي، مما يوفر عليك الوقت والجهد أثناء أداء مناسك العمرة.
              </p>
              <p>
                للحجز والاستفسار عن <strong className="text-gray-800">أسعار رحلات العمرة من الرياض</strong>، تواصل معنا عبر واتساب على الرقم 0575179602. فريقنا متاح على مدار الساعة للرد على استفساراتكم وتأكيد الحجوزات. لا نطلب دفعاً إلكترونياً مسبقاً — التأكيد يتم عبر واتساب مباشرة.
              </p>
            </div>

            {/* Service Areas */}
            <div className="mt-8 pt-8 border-t border-gray-100">
              <h4 className="font-cairo font-bold text-gray-900 mb-4 text-center">مناطق الخدمة</h4>
              <p className="text-gray-600 font-cairo text-center mb-4 text-sm">مكتبنا الرئيسي في الرياض — ننطلق من الرياض يومياً</p>
              <div className="flex flex-wrap justify-center gap-3">
                <span className="inline-flex items-center gap-1 bg-brown-50 text-brown-700 px-4 py-2 rounded-full text-sm font-cairo font-medium">
                  <MapPin size={14} />
                  الرياض
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
